import React from 'react';
import type { OptionProps } from '@usealloy/component-library';
import { MultiSelectComponents } from '@usealloy/component-library';
import type { ActionValueOption } from '../types';
import Content from './Content';


interface AddLinkedChildActionSingleValueProps extends OptionProps<ActionValueOption, false> { }
export default function AddLinkedChildActionSingleValue(
  props: AddLinkedChildActionSingleValueProps,
) {
  return (
    <MultiSelectComponents.SingleValue {...props}>
      <Content {...props} />
    </MultiSelectComponents.SingleValue>
  );
}
